
export const root = {
    background: '{overlay.modal.background}',
    borderColor: '{surface.border}',
    color: '{text.color}',
    borderRadius: '{border.radius.lg}',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    borderWidth: '1px'
};

export const header = {
    padding: '1rem 1.25rem',
    gap: '0.5rem',
    borderBottom: 'none',
    background: 'transparent',
    borderRadius: '{border.radius.lg} {border.radius.lg} 0 0'
};

export const title = {
    fontSize: '0.9375rem', // 15px — compact, like Linear
    fontWeight: '400'
};

export const content = {
    padding: '1.25rem'
};

export const footer = {
    padding: '0.5rem 1.25rem 1.25rem',
    gap: '0.5rem',
    borderTop: 'none'
};

export default {
    root,
    header,
    title,
    content,
    footer
};
